import { Grid, Typography } from "@mui/material";
import { useState, useEffect } from "react";
import DoughnutChart from "../../../components/charts/DoughnutChart";
import { isBrand } from "../../../global/environmentVariables";
import BarChart from "../../../components/charts/BarChart";

const masterColors = {
  0: {
    color: {
      backgroundColor: "#484ca0",
      borderColor: "#484ca0",
    },
  },
  1: {
    color: {
      backgroundColor: "#6052a3",
      borderColor: "#6052a3",
    },
  },
  2: {
    color: {
      backgroundColor: "#7d58a5",
      borderColor: "#7d58a5",
    },
  },
  3: {
    color: {
      backgroundColor: "#9f5ea6",
      borderColor: "#9f5ea6",
    },
  },
  4: {
    color: {
      backgroundColor: "#d260a4",
      borderColor: "#d260a4",
    },
  },
  5: {
    color: {
      backgroundColor: "#f16fa7",
      borderColor: "#f16fa7",
    },
  },
  6: {
    color: {
      backgroundColor: "#03ae9b",
      borderColor: "#03ae9b",
    },
  },
};

const stats = isBrand("shard-bugs")
  ? [
          {
            label: "Card Types",
            field: "cardType",
            list: "cardTypes",
            type: "doughnut",
            keys: {
              Bug: {
                order: 1,
                color: {
                  backgroundColor: "#ed156b",
                  borderColor: "#ed156b",
                },
              },
              Item: {
                order: 2,
                color: {
                  backgroundColor: "#18489b",
                  borderColor: "#18489b",
                },
              },
              Action: {
                order: 3,
                color: {
                  backgroundColor: "#882a87",
                  borderColor: "#882a87",
                },
              },
              Support: {
                order: 4,
                color: {
                  backgroundColor: "#00b79d",
                  borderColor: "#00b79d",
                },
              },
            },
          },
          {
            label: "Cards",
            field: "name",
            type: "doughnut",
            keys: masterColors,
          },
          {
            label: "Dust Cost",
            field: "totalCost",
            type: "barchart",
            keys: masterColors,
          },
          {
            label: "Devotion",
            field: "devotion",
            type: "barchart",
            keys: masterColors,
          },
          {
            label: "Attack",
            field: "attack",
            type: "barchart",
            keys: masterColors,
          },
          {
            label: "Defence",
            field: "defence",
            type: "barchart",
            keys: masterColors,
          },
        ]
      : [
          {
            label: "Card Types",
            field: "cardType",
            list: "cardTypes",
            type: "doughnut",
            keys: {
              Attack: {
                order: 1,
                color: {
                  backgroundColor: "#d25421",
                  borderColor: "#933a17",
                },
              },
              Block: {
                order: 2,
                color: {
                  backgroundColor: "#7e9cc0",
                  borderColor: "#586d86",
                },
              },
            },
          },
          {
            label: "Cards",
            field: "name",
            type: "doughnut",
            keys: {
              Rock: {
                order: 1,
                color: {
                  backgroundColor: "#485693",
                  borderColor: "#323c66",
                },
              },
              Paper: {
                order: 2,
                color: {
                  backgroundColor: "#B6A7A0",
                  borderColor: "#7f7470",
                },
              },
              Scissors: {
                order: 3,
                color: {
                  backgroundColor: "#d25421",
                  borderColor: "#933a17",
                },
              },
              Lizard: {
                order: 4,
                color: {
                  backgroundColor: "#a3bf75",
                  borderColor: "#728551",
                },
              },
              Spock: {
                order: 5,
                color: {
                  backgroundColor: "#7e9cc0",
                  borderColor: "#586d86",
                },
              },
            },
          },
        ];

export default function ArmyStats(props) {
  const { cardUtil, armyList, deckFormat } = props;

  const [deckStats, setDeckStats] = useState(null);
  useEffect(() => {
    let ds = {
      cardCount: 0,
    };

    let foundCharacter = false;

    if (armyList?.armyListContent) {
      for (let cardCategory of Object.values(armyList?.armyListContent)) {
        if (cardCategory.cards && !cardCategory.excludeFromTotal) {
          for (let card of Object.values(cardCategory.cards)) {
            if (!cardCategory.excludeFromTotal) {
              ds.cardCount += card.qty;
            }
            let qty = card.qty;
            if (!foundCharacter && card.id === armyList?.characterId) {
              foundCharacter = true;
              qty--;
              if (qty <= 0) continue;
            }

            for (let stat of stats) {
              if (
                card[stat.field] === undefined &&
                stat.undefined === undefined
              ) {
                continue;
              }
              if (!ds[stat.field]) {
                ds[stat.field] = {};
              }
              if (
                !ds[stat.field][
                  card[stat.field] !== undefined
                    ? card[stat.field]
                    : stat.undefined
                ]
              ) {
                ds[stat.field][
                  card[stat.field] !== undefined
                    ? card[stat.field]
                    : stat.undefined
                ] = 0;
              }
              ds[stat.field][
                card[stat.field] !== undefined
                  ? card[stat.field]
                  : stat.undefined
              ] += qty;
            }
          }
        }
      }

      for (let stat of stats) {
        if (!ds[stat.field]) {
          ds[stat.field] = [];
        } else {
          let data = [];
          let list = cardUtil[stat.list];
          if (list) {
            if (!Array.isArray(list)) {
              list = Object.values(list);
              list = list.map((el) => {
                if (typeof el === "string") return el;
                return el.name;
              });
            }

            if (stat.undefined) {
              list.unshift(stat.undefined);
            }
            let keys = Object.keys(ds[stat.field]).sort();
            for (let key of keys) {
              if (!list.includes(key)) {
                list.push(key);
              }
            }
            for (let key of list) {
              if (ds[stat.field][key] !== undefined) {
                let colors = stat.keys?.[key]?.color || {};
                data.push({
                  x: key,
                  y: ds[stat.field][key],
                  ...colors,
                });
              }
            }
          } else {
            let keys = Object.keys(ds[stat.field]).sort((a, b) => {
              return 0;
            });
            for (let key of keys) {
              let colors = stat.keys?.[key]?.color || {};
              data.push({
                x: key,
                y: ds[stat.field][key],
                ...colors,
              });
            }
          }
          ds[stat.field] = data;
        }
      }
    }

    setDeckStats(ds);
    // eslint-disable-next-line
  }, [armyList]);

  return (
    <Grid container sx={{ gap: 2 }}>
      <Grid
        item
        xs={12}
        sx={{
          p: 1,
          backgroundColor:
            deckStats?.cardCount !== undefined &&
            deckFormat?.deckSize?.min !== undefined &&
            deckStats?.cardCount < deckFormat?.deckSize?.min
              ? "error.main"
              : "background.secondary",
          color:
            deckStats?.cardCount !== undefined &&
            deckFormat?.deckSize?.min !== undefined &&
            deckStats?.cardCount < deckFormat?.deckSize?.min
              ? "error.contrastText"
              : null,
          borderRadius:
            deckStats?.cardCount !== undefined &&
            deckFormat?.deckSize?.min !== undefined &&
            deckStats?.cardCount < deckFormat?.deckSize?.min
              ? 1
              : null,
        }}
      >
        <Typography variant="h4">
          Number of Cards: {deckStats?.cardCount || 0}
        </Typography>
      </Grid>
      {deckStats &&
        stats.map((stat, index) => {
          if (!deckStats[stat.field]?.length) return <></>;
          if (stat.type === "doughnut")
            return (
              <Grid
                key={index}
                item
                sx={{
                  width: [
                    "100%",
                    "100%",
                    `calc(${100 / 2}% - 8px)`,
                    `calc(${100 / 3}% - 16px)`,
                  ],
                  maxWidth: [
                    "100%",
                    "100%",
                    `calc(${100 / 2}% - 8px)`,
                    `calc(${100 / 3}% - 16px)`,
                  ],
                }}
              >
                <DoughnutChart
                  data={deckStats[stat.field]}
                  label={stat.label}
                  heading={stat.heading || stat.label}
                />
              </Grid>
            );
          if (stat.type === "barchart")
            return (
              <Grid
                key={index}
                item
                sx={{
                  width: [
                    "100%",
                    "100%",
                    `calc(${100 / 2}% - 8px)`,
                    `calc(${100 / 3}% - 16px)`,
                  ],
                  maxWidth: [
                    "100%",
                    "100%",
                    `calc(${100 / 2}% - 8px)`,
                    `calc(${100 / 3}% - 16px)`,
                  ],
                }}
              >
                <BarChart
                  data={deckStats[stat.field]}
                  label={stat.label}
                  heading={stat.heading || stat.label}
                />
              </Grid>
            );
          return <></>;
        })}
    </Grid>
  );
}
